
export default {
  name: "OrganisationsRoot",
};
